module.exports = __webpack_public_path__ + "static/media/loader.85130f84.gif";